enum PriceRecommendationFeedbackVerdict {
	RATE_TOO_HIGH = 'RATE_TOO_HIGH',
	RATE_TOO_LOW = 'RATE_TOO_LOW',
	KEEP_CURRENT_RATE = 'KEEP_CURRENT_RATE',
}

export default PriceRecommendationFeedbackVerdict;
